import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "Error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Final = _resolveComponent("Final")!

  return (_openBlock(), _createBlock(_component_Final, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[8] || (_cache[8] = _createElementVNode("i", { class: "lnr-redo2 GeoIcon" }, null, -1 /* CACHED */)),
        (_ctx.savingError)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "MainHeading" }, " We could not save your geotargeting settings. ", -1 /* CACHED */)),
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "SubHeading" }, " Something seems to be wrong with the system. Please try again a few times. If it still does not work, quit and submit a bug. ", -1 /* CACHED */)),
              _createElementVNode("button", {
                class: "GeoHelperButton",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCampaignData()))
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("span", null, "Try Again", -1 /* CACHED */)
              ]))])
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "MainHeading" }, " Something went wrong ", -1 /* CACHED */)),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "SubHeading" }, " Something seems to be wrong with the system. Please close and open the application. If it still does not work, submit a bug. ", -1 /* CACHED */))
            ], 64 /* STABLE_FRAGMENT */)),
        _createElementVNode("button", {
          class: "GeoHelperButton LowPriority",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeApp()))
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("span", null, "Quit", -1 /* CACHED */)
        ]))])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}